import { graphql } from "gatsby";
import { MessagesBasic } from "../../../../src/examples/components/Messages";
import * as React from 'react';
export default {
  graphql,
  MessagesBasic,
  React
};